<template>
  <div class="r-initials-icon text-body-3" :style="{ '--size': size }" :class="[bgClass, colorClass]">
    <template v-if="initials">{{ initials }}</template>
    <!-- Slot can be used for example for tooltip -->
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '28px'
    },

    bgClass: {
      type: String,
      default: 'bg-graph-to-renew'
    },

    colorClass: {
      type: String,
      default: 'text-white-1'
    },

    text: String
  },

  computed: {
    initials() {
      if (!this.text || !this.text.trim()) return

      const textToArray = this.text.trim().split(' ')

      if (textToArray.length === 1) return `${textToArray[0].charAt(0)}`
      else return `${textToArray[0].charAt(0)}${textToArray[textToArray.length - 1].charAt(0)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.r-initials-icon {
  width: var(--size);
  height: var(--size);
  border-radius: var(--r-space-md);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
